/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FavritApp } from './FavritApp';
import {
    FavritAppFromJSON,
    FavritAppFromJSONTyped,
    FavritAppToJSON,
    FavritAppToJSONTyped,
} from './FavritApp';
import type { PaymentProvider } from './PaymentProvider';
import {
    PaymentProviderFromJSON,
    PaymentProviderFromJSONTyped,
    PaymentProviderToJSON,
    PaymentProviderToJSONTyped,
} from './PaymentProvider';
import type { CountryCode } from './CountryCode';
import {
    CountryCodeFromJSON,
    CountryCodeFromJSONTyped,
    CountryCodeToJSON,
    CountryCodeToJSONTyped,
} from './CountryCode';

/**
 * 
 * @export
 * @interface PaymentMethodCountryConnectionDto
 */
export interface PaymentMethodCountryConnectionDto {
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    externalId: string;
    /**
     * 
     * @type {PaymentProvider}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentProvider: PaymentProvider;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentMethod: string;
    /**
     * 
     * @type {CountryCode}
     * @memberof PaymentMethodCountryConnectionDto
     */
    countryCode: CountryCode;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryConnectionDto
     */
    paymentsEnabled: boolean;
    /**
     * 
     * @type {Set<FavritApp>}
     * @memberof PaymentMethodCountryConnectionDto
     */
    defaultEnabledInApps: Set<FavritApp>;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodCountryConnectionDto
     */
    isActive: boolean;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    activeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    activeTo?: Date;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    createdByUserEmail: string;
    /**
     * 
     * @type {string}
     * @memberof PaymentMethodCountryConnectionDto
     */
    updatedByUserEmail: string;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    created: Date;
    /**
     * 
     * @type {Date}
     * @memberof PaymentMethodCountryConnectionDto
     */
    updated: Date;
}



/**
 * Check if a given object implements the PaymentMethodCountryConnectionDto interface.
 */
export function instanceOfPaymentMethodCountryConnectionDto(value: object): value is PaymentMethodCountryConnectionDto {
    if (!('externalId' in value) || value['externalId'] === undefined) return false;
    if (!('paymentProvider' in value) || value['paymentProvider'] === undefined) return false;
    if (!('paymentMethod' in value) || value['paymentMethod'] === undefined) return false;
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('paymentsEnabled' in value) || value['paymentsEnabled'] === undefined) return false;
    if (!('defaultEnabledInApps' in value) || value['defaultEnabledInApps'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('activeFrom' in value) || value['activeFrom'] === undefined) return false;
    if (!('createdByUserEmail' in value) || value['createdByUserEmail'] === undefined) return false;
    if (!('updatedByUserEmail' in value) || value['updatedByUserEmail'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('updated' in value) || value['updated'] === undefined) return false;
    return true;
}

export function PaymentMethodCountryConnectionDtoFromJSON(json: any): PaymentMethodCountryConnectionDto {
    return PaymentMethodCountryConnectionDtoFromJSONTyped(json, false);
}

export function PaymentMethodCountryConnectionDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodCountryConnectionDto {
    if (json == null) {
        return json;
    }
    return {
        
        'externalId': json['externalId'],
        'paymentProvider': PaymentProviderFromJSON(json['paymentProvider']),
        'paymentMethod': json['paymentMethod'],
        'countryCode': CountryCodeFromJSON(json['countryCode']),
        'paymentsEnabled': json['paymentsEnabled'],
        'defaultEnabledInApps': (new Set((json['defaultEnabledInApps'] as Array<any>).map(FavritAppFromJSON))),
        'isActive': json['isActive'],
        'activeFrom': (new Date(json['activeFrom'])),
        'activeTo': json['activeTo'] == null ? undefined : (new Date(json['activeTo'])),
        'createdByUserEmail': json['createdByUserEmail'],
        'updatedByUserEmail': json['updatedByUserEmail'],
        'created': (new Date(json['created'])),
        'updated': (new Date(json['updated'])),
    };
}

export function PaymentMethodCountryConnectionDtoToJSON(json: any): PaymentMethodCountryConnectionDto {
    return PaymentMethodCountryConnectionDtoToJSONTyped(json, false);
}

export function PaymentMethodCountryConnectionDtoToJSONTyped(value?: PaymentMethodCountryConnectionDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'externalId': value['externalId'],
        'paymentProvider': PaymentProviderToJSON(value['paymentProvider']),
        'paymentMethod': value['paymentMethod'],
        'countryCode': CountryCodeToJSON(value['countryCode']),
        'paymentsEnabled': value['paymentsEnabled'],
        'defaultEnabledInApps': (Array.from(value['defaultEnabledInApps'] as Set<any>).map(FavritAppToJSON)),
        'isActive': value['isActive'],
        'activeFrom': value['activeFrom'].toISOString(),
        'activeTo': value['activeTo'] == null ? value['activeTo'] : value['activeTo'].toISOString(),
        'createdByUserEmail': value['createdByUserEmail'],
        'updatedByUserEmail': value['updatedByUserEmail'],
        'created': value['created'].toISOString(),
        'updated': value['updated'].toISOString(),
    };
}

